// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ODzlE","rightAdornment":"Header_rightAdornment__3l_c8"};